import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type BulkFormFooterProps = ComponentProps<"div">

function BulkFormFooter(props: BulkFormFooterProps) {
  const { className, ...divProps } = props
  return <div className={cn("bulk-form-footer", className)} {...divProps} />
}

export default BulkFormFooter
